export interface DbBusinessCategory {
  id: string;
  name: string;
  images?: string[];
  active?: boolean;
}

export interface DbBusinessService {
  id: string;
  description?: string;
  name: string;
  price: number;
  pricing_starts_at: boolean;
  service_duration: number; // in milliseconds
  limit_to_calendars: boolean;
  associated_entities: string[];
  special_hours: any;
  minimum_notice_period?: number;
  mandatory_confirmation?: boolean;
  mandatory_advance_percentage?: number;
  allow_multiple_timeslots: boolean;
  index?: number;
  category_id?: string;
  service_status: DbServiceStatus;
  service_images: DbBusinessServiceMedia[];
}

export interface DbBusinessServiceMedia {
  blur_hash: string;
  is_primary: boolean;
  url: string;
}

export interface DbBusinessServiceCategory {
  id: string;
  name: string;
  index: number;
  image?: string;
  category_status: DbServiceCategoryStatus;
  services: DbBusinessService[];
}

export interface DbBusinessConsumedSlot {
  booking_id: string;
  business_id: string;
  entity_id: string;
  start_date: FirestoreTimestamp;
  end_date: FirestoreTimestamp;
}

interface FirestoreTimestamp {
  _seconds?: number;
  seconds?: number;
  _nanoseconds?: number;
  nanoseconds?: number;
}

export enum DbServiceStatus {
  enable = "enable",
  disable = "disable",
  deleted = "deleted",
}

export enum DbServiceCategoryStatus {
  enable = "enable",
  deleted = "deleted",
}
